import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-plus",
  "use": "default-plus-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"default-plus\"><path d=\"M27.5 50h-5V27.5H0v-5h22.5V0h5v22.5H50v5H27.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol